import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		language: "en",
		accessToken: "",
		customerData: null,
		customerDataLoaded: false,
		customerDataLoading: false,
	}
	// ,
	// mutations: {
	// 	changeLanguage(newLanguage) {
	// 		state.language = newLanguage;
	// 	}
	// }
	// actions: {}
});
